import {
  addMonths,
  getYear,
  getMonth,
  getDate,
  isSameMonth,
  isBefore,
  setDate
} from 'date-fns';

import { getDaysDiff } from '../../utils/DateRangeHandler';

import { getDateAsUTC } from '../../utils/dateUtils';

const getOccupancies = (unavailabilities, today = getDateAsUTC(new Date())) => {
  const result = {};

  function addIndexedOccupancy(year, month, fromDay, toDay) {
    result[year] = result[year] || {};
    result[year][month] = result[year][month] || [];
    result[year][month] = [
      ...result[year][month],
      { from: fromDay, to: toDay }
    ];
  }

  unavailabilities.forEach(occupancy => {
    const fromDate = getDateAsUTC(new Date(occupancy.from));
    const toDate = getDateAsUTC(new Date(occupancy.to));

    if (getDaysDiff(today, toDate) >= 0) {
      let fromDateIt = fromDate;
      while (isBefore(fromDateIt, toDate) || isSameMonth(fromDateIt, toDate)) {
        const endDay = isSameMonth(fromDateIt, toDate) ? getDate(toDate) : -1;

        addIndexedOccupancy(
          getYear(fromDateIt),
          getMonth(fromDateIt),
          getDate(fromDateIt),
          endDay
        );

        fromDateIt = addMonths(fromDateIt, 1);
        fromDateIt = setDate(fromDateIt, 1);
      }
    }
  });

  return result;
};

export default getOccupancies;
